import React from "react";
import NotFound from "../NotFound";
import { RichText } from "prismic-reactjs";
import Loader from "../Loader";
import PageHeader from "../PageHeader";
import ImageWithtext from "../slices/ImageWithText";

// Declare your component
export default class FocusAreaItemPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      doc: null,
      notFound: false,
      imageWithTextSlices: null
    };
    if (props.prismicCtx) {
      this.fetchPage(props);
    }
  }

  componentDidUpdate(prevProps) {
    // this.props.prismicCtx.toolbar();
    // We fetch the page only after props have changed and PrismicCtx is no longer null
    if (!prevProps.prismicCtx) {
      this.fetchPage(this.props);
    }
  }

  fetchPage(props) {
    // We are using the function to get a document by its uid
    return props.prismicCtx.api.getByUID(
      "focus_area",
      props.match.params.uid,
      {},
      (err, doc) => {
        if (doc) {
          // We put the retrieved content in the state as a doc variable
          const imageWithTextSlices = doc.data.body1.find(
            item => item.slice_type === "image_with_text"
          );

          this.setState({ doc, imageWithTextSlices });
        } else {
          // We changed the state to display error not found if no matched doc
          this.setState({ notFound: !doc });
        }
      }
    );
  }

  render() {
    if (this.state.doc) {
      const doc = this.state.doc;

      return (
        <div className="main">
          {doc.data.header_image && doc.data.header_image.url ? (
            <img src={doc.data.header_image.url} alt="header-img" className="btn-block pt-5" />
          ) : (
            <PageHeader title={RichText.asText(doc.data.title)} />
          )}
          
          <div className="container pt-5 pb-5">
            <div className="row">
                <div className="col-12 col-md-8 col-lg-7">
                  <div className="body">
                    {RichText.render(
                      doc.data.body,
                      this.props.prismicCtx.linkResolver
                    )}
                  </div>
                  {this.state.imageWithTextSlices ? (
                    <ImageWithtext
                      data={this.state.imageWithTextSlices}
                      prismicCtx={this.props.prismicCtx}
                    />
                  ) : null}
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.notFound) {
      return <NotFound />;
    }
    return <Loader />;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/FocusAreaItemPage.js